export type TagSuggestionPromptInput = {
  referenceNumber: string
  submissionText: string
  issueCategory?: string
  affectedSystem?: string
  kbVocabulary: Array<{ title: string; slug: string }>
}

export function buildTagSuggestionPrompt(input: TagSuggestionPromptInput): {
  system: string
  user: string
} {
  const vocabulary =
    input.kbVocabulary.length > 0
      ? input.kbVocabulary.map((e) => `- ${e.title} (${e.slug})`).join('\n')
      : '(No knowledge base entries found — use descriptive labels from the ticket text.)'

  const contextFields = [
    input.issueCategory && `Issue category: ${input.issueCategory}`,
    input.affectedSystem && `Affected system: ${input.affectedSystem}`,
  ]
    .filter(Boolean)
    .join('\n')

  return {
    system: [
      'You assign concise, searchable tags to manufacturing support tickets.',
      'Tags must come from the provided knowledge base vocabulary when possible.',
      'Choose only tags that are directly relevant to the ticket content.',
      'Return between 1 and 5 tags. Prefer KB slug values as tag text for consistency.',
      'If no KB entry is relevant, use a short descriptive phrase (2–4 words, lowercase, hyphenated).',
      'reasoning: one sentence explaining your choices.',
    ].join(' '),
    user: [
      `Ticket reference: ${input.referenceNumber}`,
      contextFields ? `\nContext:\n${contextFields}` : '',
      '',
      'Submission:',
      input.submissionText,
      '',
      'Available KB vocabulary (preferred tag sources):',
      vocabulary,
    ]
      .filter((l) => l !== '')
      .join('\n'),
  }
}
